<template>
  <card-layout
    :image-src="technoImg"
    image-alt="Technical break"
    title="Techno magic"
    description="Sit back and relax while the magic happens. Right now we are making Finsei a better place. Please come back soon, when we're done."
    action-text="Contact support"
    action-component="a"
    :action-props="{ href: 'mailto:' + settings.email_support }"
  />
</template>

<script setup>
import { useHead } from '@unhead/vue'
import { storeToRefs } from 'pinia'
import CardLayout from '@/components/CardLayout.vue'
import { useInitStore } from '@/stores/init'
import technoImg from '@/assets/images/techno.png'

const initStore = useInitStore()
const { settings } = storeToRefs(initStore)

useHead(() => ({
  title: 'Page not found',
}))
</script>
